import { useNavigate } from 'react-router-dom'
import { BackIcon } from '../../images/Icons'
import { selectPromptOkCancelOnClick } from './menuSlice'
import '../../App.css'
import { useAppSelector } from '../../app/hooks'
import { useDispatch } from 'react-redux'
import { MessageBoxAction, setMessageBoxAction } from '../messageBoxes/messageBoxSlice'

export function BackButton() {
    const promptOkCancelOnClick = useAppSelector(selectPromptOkCancelOnClick)
    const navigate = useNavigate()
    const dispatch = useDispatch()
    
    return (
        <div className='iconButton' onClick={() => {
            if (promptOkCancelOnClick) {
                dispatch(setMessageBoxAction(MessageBoxAction.GoBack))
                navigate('/MessageBox')
            }
            else 
                navigate(-1)
        }}>
            <BackIcon />
        </div>
    )
}